import { render, staticRenderFns } from "./addGrouping.vue?vue&type=template&id=4c98b58a&scoped=true&"
import script from "./addGrouping.vue?vue&type=script&lang=js&"
export * from "./addGrouping.vue?vue&type=script&lang=js&"
import style0 from "./addGrouping.vue?vue&type=style&index=0&id=4c98b58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c98b58a",
  null
  
)

export default component.exports